module.exports = __webpack_public_path__ + "img/2.110371ce.png";